export default function PrivacyPolicyPage() {
  return (
    <div className="w-full min-h-screen bg-gray-100">
      <div className="w-full h-screen sm:h-[90vh] md:h-full">
        <iframe
          src="/policy.html"
          title="Privacy Policy"
          className="w-full h-full border-none"
          style={{
            minHeight: "100vh",
          }}
        ></iframe>
      </div>
    </div>
  );
}
